import React from 'react';
interface SectionHeadingProps {
  children: React.ReactNode;
}
export function SectionHeading({
  children
}: SectionHeadingProps) {
  return <h2 className="text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)] font-semibold tracking-tight text-[#111111] animate-fadeIn" data-id="element-240">
      {children}
    </h2>;
}